import { combineEpics } from "redux-observable";
import expAlertEpics from "@ane/expalert/lib/module/epics";
import expTemplateEpics from "@ane/exptemplate/lib/module/epics";
import "./views/Create/epics/CreateExpEpics.js";
import { detailsViewEpics } from "./views/Details/epics/DetailsViewEpics.js";
import { flightsEpics } from "./views/Details/epics/FlightsEpics.js";
import epic from "./views/Create/components/ExperimentCreateContainer/ExperimentCreateContainer.epic.js";
const rootEpic = combineEpics(detailsViewEpics, flightsEpics, expAlertEpics, expTemplateEpics, epic);
export {
  rootEpic as default
};
//# sourceMappingURL=epics.js.map
